import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ExtractorTimeZoneSpecificationsRoute } from '../../routing'

export class ExtractorTimeZoneSpecificationsPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ExtractorTimeZoneSpecificationsRoute />
            </Fragment>
        )
    }
}
